import {getThemeName} from "./themeUtils";
import { i18n } from '@lingui/core';

export function getPdfFonts() {
    const themeName = getThemeName();
    switch (themeName) {
        case "acl":
        case "cfc":
            return [
                {src: "/fonts/Quicksand-Medium.ttf"},
                {src: "/fonts/Quicksand-Bold.ttf", fontWeight: 600}
            ];
        default:
            return [
                {src: "/fonts/tuitypelight.ttf"},
                {src: "/fonts/tuitypelight-bd.ttf", fontWeight: 600}
            ];
    }
}
export function getInstructionsTitleStyles() {
    const themeName = getThemeName();
    switch (themeName) {
        case "acl":
            return {fontSize: "16px", color: "#009165"};
        case "cfc":
            return {fontSize: "12px", color: "#6B207D"};
        default:
            return {fontSize: "18px", color: "#092a5e"};
    }
}

export function getBulletPointStyles(fontSize) {
    const themeName = getThemeName();
    switch (themeName) {
        case "acl":
            return {marginTop: `${fontSize ? (parseInt(fontSize)+ 1) / 2  + "px" : "4.5px"}`, width: "3px", height: "3px", backgroundColor: "#F68C4E", borderRadius: 100};
        case "cfc":
            return {marginTop: `${fontSize ? (parseInt(fontSize)+ 1) / 2  + "px" : "4.5px"}`, width: "3px", height: "3px", backgroundColor: "#090A31", borderRadius: 100};
        default:
            return {width: "5px", height: "5px", backgroundColor: "#092a5e"};
    }
}

export function getDarkBrandColor() {
    const themeName = getThemeName();
    switch (themeName) {
        case "acl":
            return "#380843";
        case 'cfc':
            return "#090A31";
        case 'resco':
            return "#263345";
        default:
            return "#092a5e";
    }
}

export function getPrimaryBrandColor() {
    const themeName = getThemeName();
    switch (themeName) {
        case "acl":
        case "cfc":
            return "#6B207D";
        default:
            return "#092a5e";
    }
}

export function getLabelColor() {
    const themeName = getThemeName();
    switch (themeName) {
        case "acl":
            return "#6B207D";
        case "cfc":
            return "#000000";
        default:
            return "#092a5e";
    }
}

export function getBorderStyle() {
    return `1px dashed ${getDarkBrandColor()}`;
}

export function getCircledLetterStyles(color) {
    const themeName = getThemeName();
    switch (themeName) {
        case "acl":
            return {
                fontSize: "12px",
                paddingTop: "1px",
                color: color,
                border: `1px solid ${color}`,
            };
        case "cfc":
            return {
                fontSize: "10px",
                paddingTop: "1px",
                color: color,
                border: `1px solid ${color}`,
            };
        default:
            return {
                fontSize: "14px",
                paddingTop: "1px",
                color: getDarkBrandColor(),
                border: `1px solid ${getDarkBrandColor()}`,
            };
    }
}

export function getStandardInstructions() {
    const locale = i18n.locale;
    switch (locale) {
        case "fr":
            return [
                {text: "Avant de quitter votre domicile, assurez-vous d'indiquer sur chaque bagage des informations permettant de vous identifier, telles que votre nom."},
                {text: "Ne mettez pas d'objets de valeur ou vos documents d'embarquement dans vos bagages enregistrés."},
                {text: "Faites autant de copies de cette étiquette que vous le souhaitez, de préférence imprimées en couleur."},
                {text: "Pliez (ne coupez pas) le long des lignes pointillées, l'étiquette bagage imprimée vers l'extérieur (vous devez pouvoir voir le logo de la compagnie)."},
                {text: "Une fois le pliage terminé, agrafez deux fois ou scotchez l'étiquette autour de la poignée du bagage."},
            ]
        default:
            return [
                {text: "Be sure to attach any personal ID, such as a name tag to each piece of luggage before you leave home."},
                {text: "Do not pack valuables or your boarding documents in your checked luggage."},
                {text: "Make as many copies of this tag as you require, preferably printed in colour."},
                {text: "Fold (do not cut) along the dotted lines with the luggage tag facing out (you should be able to see the company logo)."},
                {text: "After folding is completed, staple twice or tape the tag around the luggage handle."},
            ]
    }
}

export function getDisembarkInstructions() {
    const locale = i18n.locale;
    switch (locale) {
        case "fr":
            return [
                {style: {fontSize: "8.5px"}, text: "Cette étiquette ne doit être utilisée que pour le débarquement. Votre « étiquette d'embarquement » doit être attachée à vos bagages le jour du départ. Vous ne devez remplacer l'étiquette d'embarquement par cette «"},
                {style: {fontSize: "8.5px"}, text: "Veillez à ajouter vos informations sur l'étiquette et en attacher une sur chaque bagage."},
                {style: {fontSize: "8.5px"}, text: "Conservez tout objet de valeur ou document de voyage dans votre bagage à main."},
                {style: {fontSize: "8.5px"}, text: "Faites autant de copies de cette étiquette que vous le souhaitez, de préférence imprimées en couleur."},
                {style: {fontSize: "8.5px"}, text: "Pliez (ne coupez pas) le long des lignes pointillées, l'étiquette bagage imprimée vers l'extérieur (vous devez pouvoir voir le logo de la compagnie)."},
                {style: {fontSize: "8.5px"}, text: "Une fois le pliage terminé, agrafez deux fois ou scotchez l'étiquette autour de la poignée du bagage."},
            ]
        default:
            return [
                {style: {fontSize: "8.5px"}, text: "This label is to be used for Disembarkation only. Your ‘Embarkation Label’ should be attached to your luggage on the day of sailing. You should only replace the embarkation label with this ‘Victoria Coach Disembarkation Label’ once onboard."},
                {style: {fontSize: "8.5px"}, text: "Be sure to attach any personal ID, such as a name tag to each piece of luggage."},
                {style: {fontSize: "8.5px"}, text: "Keep any valuables or any travel documents in your hand luggage."},
                {style: {fontSize: "8.5px"}, text: "Make as many copies of this tag as you require, preferably printed in colour."},
                {style: {fontSize: "8.5px"}, text: "Fold (do not cut) along the dotted lines with the luggage tag facing out (you should be able to see the company logo)."},
                {style: {fontSize: "8.5px"}, text: "After folding is completed, staple twice or tape the tag around the luggage handle."},
            ]
}
}

export function getWheelchairInstructions() {
    const locale = i18n.locale;
    switch (locale) {
        case "fr":
            return [
                {text: "Cette étiquette doit être attachée à votre fauteuil roulant à tout moment de la navigation.", style: {fontSize: "13px", fontWeight: "bold"}},
                {text: "Faites autant de copies de cette étiquette que vous le souhaitez, de préférence imprimées en couleur."},
                {text: "Pliez (ne coupez pas) le long des lignes pointillées, l'étiquette bagage imprimée vers l'extérieur (vous devez pouvoir voir le logo de la compagnie)."},
                {text: "Une fois le pliage terminé, agrafez deux fois ou scotchez l'étiquette autour de la poignée du bagage."},
            ]
        default:
            return [
                {text: "This label should be attached to your wheelchair at all times during your sailing.", style: {fontSize: "13px", fontWeight: "bold"}},
                {text: "Make as many copies of this tag as you require, preferably printed in colour."},
                {text: "Fold (do not cut) along the dotted lines with the luggage tag facing out (you should be able to see the company logo)."},
                {text: "After folding is completed, staple twice or tape the tag around the luggage handle."},
            ]
    }
}

export function getFoldDoNotCutText() {
    const locale = i18n.locale;
    switch (locale) {
        case "fr":
            return "Plier - Ne pas couper"
        default:
            return "fold - do not cut"
    }
}

export function getLuggageTagInstructions() {
    const locale = i18n.locale;
    switch (locale) {
        case "fr":
            return "Instructions pour l'étiquette de bagage"
        default:
            return "Luggage tag instructions"
    }
}